import { h } from "preact";
import { observer } from "mobx-preact";
import cx from "classnames";
import "./index.less";
import { isMobile } from "@src/utils/device-utils";
import {useEffect, useMemo, useState} from "preact/hooks";

//const prefix = isMobile() ? "xfe-common-login-toast-mobile" : "xfe-common-login-toast";

const Toast = ({ store }) => {
  store.use();
  const [mobileStatus, setMobileStatus] = useState(window.innerWidth <= 745);
  useEffect(() => {
    window.addEventListener('resize', () => {
      setMobileStatus( window.innerWidth <= 745);
    });
  } ,[]);
  const prefix = useMemo(() => {
    return mobileStatus ? "xfe-common-login-toast-mobile" : "xfe-common-login-toast"
  }, [mobileStatus])
  return (<div id="__XFE_LOGIN_TOAST__" className={cx(`${prefix}-toast`, store?.visible && `${prefix}-show`)}>
    <div className={`${prefix}-toastMsg`}>{store?.msg}</div>
  </div>);
};

export default observer(Toast);
